import { useCallback, useState } from 'react';

export interface Settings {
    crt: boolean;
    scanlines: number;
    curvature: number;
    noise: number;
    screensaver: boolean;
}

const STORAGE_KEY = 'dkdk_settings_v2';

const defaults: Settings = {
    crt: true,
    scanlines: 0.6,
    curvature: 0.4,
    noise: 0.3,
    screensaver: false,
};

const load = (): Settings => {
    try {
        return { ...defaults, ...JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') };
    } catch (_) {
        return defaults;
    }
};

/** 화면 설정. 브라우저에 저장해 다음 방문에도 유지한다. */
export const useSettings = () => {
    const [settings, setSettings] = useState<Settings>(load);

    const updateSettings = useCallback((patch: Partial<Settings>) => {
        setSettings((prev) => {
            const next = { ...prev, ...patch };
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            } catch (_) { }
            return next;
        });
    }, []);

    return { settings, updateSettings };
};
